<template>
	<div class="mt-4 mb-4">
			<v-tabs v-model="tab" right>
				<v-tab key="form">
					{{prettyPrint(choicesKey)}}
				</v-tab>
				<v-tab-item>

						<v-row v-for="(choice, index) in choices" :key="index">
							<v-col cols="1">
								<v-btn fab dark small color="red" @click="choices.splice(index, 1)"><v-icon>mdi-close</v-icon></v-btn>
							</v-col>
							<v-col>
								<v-text-field dense v-model="choice.value" label="Value"></v-text-field>
							</v-col>
							<v-col>
								<v-text-field dense v-model="choice.text" label="Label"></v-text-field>
							</v-col>
							<v-col v-if="includeWidth">
								<v-text-field dense v-model="choice.width" placeholder="Width"></v-text-field>
							</v-col>
						</v-row>
						
					<v-btn fab color="green" dark small absolute right @click="newChoice">
						<v-icon>mdi-plus</v-icon>
					</v-btn>
				</v-tab-item>	
				<v-tab key="paste">
					Paste
				</v-tab>
				<v-tab-item>
					<v-textarea v-model="pasteChoices" label="Paste" v-on:blur="massEdited"></v-textarea>
					<small class="info--text">One choice per row. Values only or value|text</small>
				</v-tab-item>
		</v-tabs>
	</div>
</template>
<script>
	export default {
		name: "FieldChoices", 
		props: {
			question: {type: Object},
			choicesKey: {type: String, default: "choices" },
			includeWidth: {type: Boolean, default: false },
			includeTitle: {type: Boolean, default: true }
		},
		data: () => {
			return {
				tab: "form", 
				pasteChoices: '',
				choices: []

			}
		},
		methods:{
			convertStringsToObjects(){
				const self = this;
				let choices = [];
				self.choices.forEach( (choice) => {
					if( typeof choice == String ){
						choice = {value: choice, text: self.prettyPrint(choice, "SENTENCE")} 
					}
					choices.push( choice )
				})
				self.choices = choices;

			},
			newChoice(){
				this.choices.push( {value: '', text: '' })
			},
			massEdited: function(){
				const self = this;
				if( !self.pasteChoices){ return; }
				self.choices = [];
				let pasteChoices = self.pasteChoices.split("\n");
				pasteChoices.forEach( function(p){
					let split = p.split("|");
					if( split[0] ){					
						split[0] = split[0].split(" ").join("-");	
						if( !split[1] ){
							split[1] = self.prettyPrint(split[0], "SENTENCE")
						}
						self.choices.push( {value: split[0], text: split[1] })
					}
				} )
			},
		},
		watch: {
			choices: {
				immediate: false,
				deep: true,
				handler: function(){
					const self = this;
					let strings = [];
					self.choices.forEach( function(choice){
						let str = choice.value + "|" + choice.text;
						strings.push( str )
					})
					self.pasteChoices = strings.join("\n");
					self.question[self.choicesKey] = self.choices;
				}
			}
		},
		created: function(){
			const self = this;
			if( self.question[self.choicesKey] ){
				self.choices = self.question[self.choicesKey]
			}

			self.convertStringsToObjects();
		}

	}
</script>